export default "__VITE_ASSET__BtS60AhM__"